export const SELECT_LANGUAGE = 'settings/SELECT_LANGUAGE';
